import { render, staticRenderFns } from "./onlineEducation.vue?vue&type=template&id=c91fd212&scoped=true&"
import script from "./onlineEducation.vue?vue&type=script&lang=js&"
export * from "./onlineEducation.vue?vue&type=script&lang=js&"
import style0 from "./onlineEducation.vue?vue&type=style&index=0&id=c91fd212&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91fd212",
  null
  
)

export default component.exports